// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 2160px) {\n.back-btn img[data-v-b95d50b6] {\n    width: 37.5px;\n    height: 19.5px;\n}\n}", ""]);
// Exports
module.exports = exports;
